export default function Footer() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="pf-footer">
      <p className="m-0">
        © {new Date().getFullYear()}&nbsp;&mdash;&nbsp;Diseñado y construido por&nbsp;
        <button onClick={handleScrollToTop} className="pf-footer__scroll-btn">
          Ricardo López Ortiz
        </button>
      </p>
    </footer>
  );
}
